<template>
    <div class="margin-40-60-0">
        <div>
            <el-page-header @back="close" content="打印图像对照单"></el-page-header>
        </div>
        <div>
            <div style="text-align: right;margin: auto;margin-right: 200px">
                <el-button type="text" @click="downloadResult('page')" style="margin-right: 30px">导出图片</el-button>
                <el-button type="text" @click="printOutpdf('page')">导出PDF</el-button>
                <el-button type="text" v-print="`#page`">在线打印</el-button>
            </div>
        </div>
        <div style="margin-bottom: 40px;height: auto" id="page">
            <div class="page" v-if="upMajorForm">
                <div>
                    <h1 align="center">武汉晴川学院 {{new Date().getFullYear()}} 年专升本考试图像对照单上午 ({{upMajorForm.examRoomNum}})考场</h1>
                </div>
                <div style="height: auto ">
                    <div style="width: 100%;min-height: 260px;">
                        <div style="height: 248px;float: left;width: 16%;border:dashed 1px #49a2ff;margin-left: 4px;margin-bottom: 4px;font-weight: 600;" v-for="item in upStudentList">
                            <div style="width: 100%;height: 150px;text-align: center;margin:5px 5px 5px 8px">
                                <img style="height: 150px; margin-left: -15px" :src="config.resPre+item.faceImg"/>
                            </div>
                            <div style="width:100%;text-align: center;line-height: 22px">
                                <div style="height: 22px">
                                    <div style="text-align: center;width: 50%;float: left">{{item.name}}</div>
                                    <div style="text-align: center;width: 50%;float: left">{{item.seatNumber}}</div>
                                </div>
                                <div style="height: 22px;font-size: 13px">{{item.idCard}}</div>
                                <div style="height: 22px">
                                    {{item.examMajor}}
                                </div>
                                <div style="height: 22px">
                                    <div style="text-align: center;width: 40%;float: left">签字</div>
                                    <div style="text-align: center;width: 40%;float: left"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width: 100%">
                        <h1 style="text-align: right;margin-right: 210px;margin-top: 30px">监考人员签字:</h1>
                    </div>
                </div>
            </div>
            <div class="page" v-if="downMajorForm">
                <div>
                    <h1 align="center">武汉晴川学院 {{new Date().getFullYear()}} 年专升本考试图像对照单下午({{downMajorForm.examRoomNum}})考场</h1>
                </div>
                <div style="height: auto ">
                    <div style="width: 100%;min-height: 260px;">
                        <div style="height: 248px;float: left;width: 16%;border:dashed 1px #49a2ff;margin-left: 4px;margin-bottom: 4px;font-weight: 600;" v-for="item in downStudentList">
                            <div style="width: 100%;height: 150px;text-align: center;margin:5px 5px 5px 8px">
                                <img style="height: 150px; margin-left: -15px" :src="config.resPre+item.faceImg"/>
                            </div>
                            <div style="width:100%;text-align: center;line-height: 22px">
                                <div style="height: 22px">
                                    <div style="text-align: center;width: 50%;float: left">{{item.name}}</div>
                                    <div style="text-align: center;width: 50%;float: left">{{item.seatNumber}}</div>
                                </div>
                                <div style="height: 22px;font-size: 13px">{{item.idCard}}</div>
                                <div style="height: 22px">
                                    {{item.examMajor}}
                                </div>
                                <div style="height: 22px">
                                    <div style="text-align: center;width: 40%;float: left">签字</div>
                                    <div style="text-align: center;width: 40%;float: left"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width: 100%">
                        <h1 style="text-align: right;margin-right: 210px;margin-top: 30px">监考人员签字:</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    import html2canvas from 'html2canvas';
    import JsPDF from 'jspdf'
    let loading;
    export default {
        name: "sysStudentImgWrite",
        components: { noData },
        props:["title","examRoomNum","classroomNum"],
        data() {
            return {
                majorForm: {
                },
                upStudentList:[],
                downStudentList:[],
                config:config,
                upMajorForm:{},
                downMajorForm:{},
                examRoomForm:{
                    examRoomNum:'',
                    classroomNum:'',
                },
                majorList:[],

            }
        },
        created(){
            this.submit();
        },
        mounted(){
        },
        methods: {
            submit(){
                if(!this.examRoomNum || !this.classroomNum){
                    this.$message({
                        type: "error",
                        message: "数据缺失,考场号或教室号为空!"
                    });
                    this.$emit('closeSysStudentImgWrite');
                }else{
                    this.examRoomForm.examRoomNum = this.examRoomNum;
                    this.examRoomForm.classroomNum = this.classroomNum;
                    axios({
                        url:`${home}/sysExamRoom/getStudentWrite`,
                        method:'POST',
                        data:this.examRoomForm
                    }).then(res=>{
                        this.majorList = res.data[0];
                        this.upMajorForm = res.data[0][0];
                        if(res.data.length>1){
                            this.downMajorForm = res.data[0][1];
                            this.upStudentList = res.data[1];
                            this.downStudentList = res.data[2];
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            dataURLToBlob(dataurl) {//ie 图片转格式
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {type: mime})
            },
            downloadResult(name) {
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let canvasID = document.getElementById(name);
                let a = document.createElement('a');
                html2canvas(canvasID).then(canvas => {
                    let dom = document.body.appendChild(canvas);
                    dom.style.display = "none";
                    a.style.display = "none";
                    document.body.removeChild(dom);
                    let blob = this.dataURLToBlob(dom.toDataURL("image/png"));
                    a.setAttribute("href", URL.createObjectURL(blob));
                    a.setAttribute("download", "第"+this.examRoomNum+"签字表.png")
                    document.body.appendChild(a);
                    a.click();
                    URL.revokeObjectURL(blob);
                    document.body.removeChild(a);
                    loading.close();
                });
            },
            /**
             *
             * @param url 图片路径
             * @param ext 图片格式
             * @param callback 结果回调
             */
            getUrlBase64(url, ext, callback) {
                var canvas = document.createElement("canvas");   //创建canvas DOM元素
                var ctx = canvas.getContext("2d");
                var img = new Image;
                img.crossOrigin = 'Anonymous';
                img.src = url;
                img.onload = function () {
                    canvas.height = 140; //指定画板的高度,自定义
                    canvas.width = 160; //指定画板的宽度，自定义
                    ctx.drawImage(img, 0, 0, 140, 160); //参数可自定义
                    var dataURL = canvas.toDataURL("image/" + ext);
                    callback.call(this, dataURL); //回掉函数获取Base64编码
                    canvas = null;
                };

            },
            printOut(name) {
                // 个人观察只是截取可见范围以及以下的区域，所以先将滚动条置顶
                $(window).scrollTop(0); // jQuery 的方法
                document.body.scrollTop = 0; // IE的
                document.documentElement.scrollTop = 0; // 其他
                this.downloadResult(name)
            },
            printOutpdf(name) {
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let shareContent = document.getElementById(name),//需要截图的包裹的（原生的）DOM 对象
                    width = shareContent.clientWidth, //获取dom 宽度
                    height = shareContent.clientHeight, //获取dom 高度
                    canvas = document.createElement("canvas"), //创建一个canvas节点
                    scale = 2; //定义任意放大倍数 支持小数
                canvas.width = width * scale; //定义canvas 宽度 * 缩放
                canvas.height = height * scale; //定义canvas高度 *缩放
                canvas.style.width = shareContent.clientWidth * scale + "px";
                canvas.style.height = shareContent.clientHeight * scale + "px";
                canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
                let opts = {
                    scale: scale, // 添加的scale 参数
                    canvas: canvas, //自定义 canvas
                    logging: false, //日志开关，便于查看html2canvas的内部执行流程
                    width: width, //dom 原始宽度
                    height: height,
                    useCORS: true, // 【重要】开启跨域配置
                };
                html2canvas(shareContent).then(canvas => {
                    var contentWidth = canvas.width;
                    var contentHeight = canvas.height;
                    //一页pdf显示html页面生成的canvas高度;
                    var pageHeight = (contentWidth / 592.28) * 841.89;
                    //未生成pdf的html页面高度
                    var leftHeight = contentHeight;
                    //页面偏移
                    var position = 0;
                    //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                    var imgWidth = 595.28;
                    var imgHeight = (592.28 / contentWidth) * contentHeight;
                    var pageData = canvas.toDataURL("image/jpeg", 1.0);
                    var PDF = new JsPDF("", "pt", "a4");
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
                            leftHeight -= pageHeight;
                            position -= 841.89;
                            if (leftHeight > 0) {
                                PDF.addPage();
                            }
                        }
                    }
                    PDF.save("第"+this.examRoomNum+"签字表.pdf"); // 这里是导出的文件名
                    loading.close();
                });
            },
            close(){
                this.$emit('closeSysStudentImgWrite');
            },
        }
    }
</script>
<style scoped lang="scss">
    .saveOrUpdateCrud{
        margin: 20px 0 0 10px;
    }

    .page
    {
        width: 26cm;
        height: 1370px;
        padding: 1cm;
        margin: 1cm auto;
        border-radius: 5px;
        background: white;
    }
</style>
